import H_time from '@/helpers/time';
import H_factoryTag from '@/helpers/factoryTag';

export default {
  setShowData(res) {
    const {
      id,
      name,
      factory_tags,
      owner,
      created_user: creator,
    } = res;
    const factoryTags = factory_tags.map(tag => {
      return {
        text: `#${tag.name}`,
        color: 'light-gray'
      };
    });
    return {
      id,
      name,
      factoryTags,
      ownerValue: owner ? owner : {
        name: '',
        avatar: '',
      },
      owner: owner ? owner.id : '',
      creator,
    };
  },
  setUpdateData(res) {
    const {
      id,
      name,
      factory_tags,
      owner,
      created_user: creator,
    } = res;
    const factoryTags = [factory_tags.map(tag => tag.id)];
    return {
      id,
      name,
      factoryTags,
      ownerValue: owner ? owner : {
        name: '',
        avatar: '',
      },
      owner: owner ? owner.id : '',
      creator,
    };
  },
  setCard(rawDataList) {
    if (!rawDataList || rawDataList.length === 0) return [];
    const data = rawDataList.map(rawData => {
      const {id, name: title, owner, factory_tags, updated_at} = rawData;
      return {
        id,
        title,
        spec: [
          {
            title: '管理者',
            text: owner.name,
          },
          {
            title: '更新日期',
            text: H_time.getDateDashFormat(updated_at),
          },
        ],
        factoryTags: H_factoryTag.setShowInModule(factory_tags),
      };
    });
    return data;
  },
  setSubmitData(rawData) {
    const {name, owner, factoryTags} = rawData;
    return {
      name,
      owner,
      factory_tags: factoryTags[0],
    };
  },
  setCommonChoiceGroupBtnList(rawDataList) {
    return rawDataList.map(({id, name: text}) => ({id, text}));
  }
}